// Spinner.jsx
import React from 'react';
import './Spinner.css'

const Spinner = () => {
  return (
    <div className="spinner-container">
      <span className="loader">Loading</span>
    </div>
  );
};

export default Spinner;
